import React from 'react';
import Modal from './Modal';

interface RulesPopupState {
    isOpen: boolean;
}

class RulesPopup extends React.Component<{}, RulesPopupState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    open = (): void => this.setState({ isOpen: true });
    close = (): void => this.setState({ isOpen: false });

    render(): React.ReactNode {
        return (
            <>
                <button className="button game-button game-button__rules" onClick={this.open}>
                    <span className="game-button__icon">📖</span>
                    Rules
                </button>

                <Modal isOpen={this.state.isOpen} onClose={this.close} title="Light Up Rules">
                    <ul>
                        <li>Put lights around so everything is lit up.</li>
                        <li>Lights can&apos;t shine on one another.</li>
                        <li>Numbers indicate how many lights are next to them.</li>
                    </ul>

                    <p>
                        This is a classic Nikoli puzzle format.{' '}
                        <a href="https://en.wikipedia.org/wiki/Light_Up_(puzzle)">Wikipedia</a>.
                    </p>
                </Modal>
            </>
        );
    }
}

export default RulesPopup;
